import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme';


export default class SomeButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false
        }
    }

    componentDidMount = () => {
        this.detectMobile();
    }


    componentWillUnmount() { }

    detectMobile = () => {
        const width = window.innerWidth
        const isMobile = width <= theme.grid.breakpoints.md

        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile })
        }
    }

    render() {
        const { fb, linked_in, yt, twitter, justify, header, bgcolor } = this.props
        const { isMobile } = this.state

        return (
            <Wrapper fluid bgcolor={bgcolor}>
                <InnerWrapper>
                    <Row>
                        <Col
                            xs={12}
                            sm={12}
                        >
                            <Header justify={isMobile === true ? 'center' : justify}>
                                <div>{header}</div>
                            </Header>
                            <FlexContainer justify={isMobile === true ? 'center' : justify}>
                                {fb &&
                                    <SocialContainer href={fb}>
                                        <svg
                                            width="8"
                                            height="18"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M.168 6.288h1.657V4.674c0-.712.017-1.81.534-2.49.543-.719 1.29-1.209 2.574-1.209 2.09 0 2.972.3 2.972.3l-.414 2.46s-.692-.2-1.336-.2c-.645 0-1.222.23-1.222.877v1.876h2.644L7.392 8.69H4.933v8.35H1.825V8.69H.168V6.288z"
                                                fill="#FEFEFE"
                                                fillRule="evenodd"
                                            />
                                        </svg>

                                    </SocialContainer>
                                }
                                {linked_in &&
                                    <SocialContainer href={linked_in}>
                                        <svg
                                            width="17"
                                            height="15"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M16.054 14.726h-3.545V9.54c0-1.358-.553-2.284-1.773-2.284-.933 0-1.451.625-1.693 1.228-.09.216-.076.516-.076.819v5.422H5.456s.046-9.185 0-10.02h3.511v1.572c.207-.687 1.33-1.668 3.12-1.668 2.221 0 3.967 1.44 3.967 4.544v5.572zM1.905 3.452h-.022C.752 3.452.017 2.686.017 1.716c0-.99.757-1.74 1.91-1.74S3.79.724 3.813 1.713c0 .97-.732 1.739-1.907 1.739zM.422 14.726h3.126V4.706H.422v10.02z"
                                                fill="#FEFEFE"
                                                fillRule="evenodd"
                                            />
                                        </svg>
                                    </SocialContainer>
                                }
                                {yt &&
                                    <SocialContainer href={yt}>
                                        <svg
                                            width="27"
                                            height="27"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M23.55,9c-.28-1.77-1.05-2.44-2.84-2.62-2.38-.24-4.77-.29-7.15-.31h-.25c-2.36,0-4.72.08-7.07.32A2.63,2.63,0,0,0,3.51,8.92a28,28,0,0,0,0,8.53c.29,1.92,1.1,2.61,3.07,2.77a74.76,74.76,0,0,0,8.06.27,42,42,0,0,0,6.82-.42A2.42,2.42,0,0,0,23.49,18,27.25,27.25,0,0,0,23.55,9Zm-7.17,4.56L12,16.08c-.41.24-.52.11-.51-.32,0-.82,0-1.64,0-2.46s0-1.7,0-2.55c0-.4.13-.49.48-.29l4.48,2.59C16.81,13.27,16.62,13.4,16.38,13.54Z" fill="#fefefe" />
                                        </svg>
                                    </SocialContainer>
                                }
                                {twitter &&
                                    <SocialContainer href={twitter}>
                                        <svg
                                            width="27"
                                            height="27"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M24.68,6.36A14.66,14.66,0,0,1,22.13,7v0A3.85,3.85,0,0,0,24,4.52a10.5,10.5,0,0,1-2.71,1,4.61,4.61,0,0,0-8.08,3,4.54,4.54,0,0,0,.16,1.18A12.87,12.87,0,0,1,3.82,4.89c-1,2.42-.85,4.57,1.52,6.23a4.74,4.74,0,0,1-2.21-.53,4.87,4.87,0,0,0,3.68,4.67,7.41,7.41,0,0,1-1.94,0c.66,2.16,2.29,2.91,4.21,3.27-1.8,1.61-4.13,2-6.7,2,12.08,6.62,20.72-4.14,20-11.64a1.09,1.09,0,0,0,0-.18A11.36,11.36,0,0,0,24.68,6.36Z" fill="#fefefe" />
                                        </svg>
                                    </SocialContainer>
                                }
                            </FlexContainer>
                        </Col>
                    </Row>
                </InnerWrapper>
            </Wrapper>
        )
    }
}

const Wrapper = styled(Container)`
margin: 20px 0;
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
padding-top: ${props => props.bgcolor === 'grey' ? '1em' : '0'};
padding-bottom: ${props => props.bgcolor === 'grey' ? '1em' : '0'};
${media.lg`
padding: 1em 20%;
`}
`
const InnerWrapper = styled.div`
width: 100%;
`

const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: ${props => props.justify}

  ${media.xs`
    margin-top: 10px;
  `}
`

const SocialContainer = styled.a`
  background: #9BB4C8;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  display: flex;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 10px;

  &:hover {
    cursor: pointer;
  };
`
const Header = styled.div`
text-align: ${props => props.justify}
`


// WEBPACK FOOTER //
// ./src/ui/components/modules/SomeButtons/index.js